import apiClient from 'utilities/apiClient';

export const configureApi = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.configure}/${url}`, payload, true);
};

export const configureApiGet = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.configure}/${url}`, payload, true);
};
